module.exports = __webpack_public_path__ + "static/media/apartment6.fe9d58c9.jpg";